"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalBar = void 0;
var react_1 = __importDefault(require("react"));
var polyfilled_1 = __importDefault(require("use-resize-observer/polyfilled"));
var GKTooltip_1 = require("../../GKTooltip");
var GKBarChartContext_1 = require("../GKBarChartContext");
var VerticalBar = function (_a) {
    var d = _a.d, range = _a.range, qa = _a.qa;
    var barHeight = Math.abs(d.value * 100) / range + "%";
    var normedId = d.xLabel.replace(/ |\#/g, "");
    var barRef = react_1.default.createRef();
    var chart = react_1.default.useContext(GKBarChartContext_1.BarChartContext);
    var _b = react_1.default.useState(0), myHeight = _b[0], setMyHeight = _b[1];
    // Using a resize observer, because height can change on resize
    var labelRef = (0, polyfilled_1.default)({
        box: "border-box",
        onResize: function (_a) {
            var height = _a.height;
            setMyHeight(height || 0);
        },
    }).ref;
    react_1.default.useEffect(function () {
        chart.updateYLabelSize(myHeight);
    }, [chart, myHeight]);
    return (react_1.default.createElement(react_1.default.Fragment, { key: normedId },
        react_1.default.createElement("div", { id: normedId, ref: barRef, "data-qa": qa + "--bar", className: "mx-2 w-100", style: {
                backgroundColor: d.color,
                height: barHeight,
                position: "relative",
                top: d.value < 0 ? "calc(" + barHeight + " + 1px)" : "0px",
            }, 
            /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
            tabIndex: 0 },
            react_1.default.createElement("div", { className: "w-100 m-0 text-center position-absolute", "data-qa": qa + "--ylabel", style: { top: -myHeight } },
                react_1.default.createElement("b", { className: "d-block pb-2", ref: labelRef, style: { lineHeight: 1 } }, d.yLabel))),
        d.tooltip && (react_1.default.createElement(GKTooltip_1.GKTooltip, { target: barRef, "data-qa": qa + "--tooltip" }, d.tooltip))));
};
exports.VerticalBar = VerticalBar;
